@if (state.showLoadingBar) {
  <mat-progress-bar mode="indeterminate" class="page-loading-bar" />
}
<dojo-page-layout
  [wrapInsideIonContent]="false"
  [isShowBlurTopPanel]="false"
  [showHeader]="true"
  class="topic-detail-view-page block h-full pb-4"
>
  @if (state.isMobile) {
    <ion-header ion-header-content [translucent]="true" class="mobile-header">
      <ion-toolbar class="!px-0">
        <div class="small:mx-auto flex items-center justify-between pr-4">
          <div
            slot="start"
            class="flex h-[52px] w-[50px] items-center justify-center"
            [routerLink]="`/${RootUrlParts.LearnHub}`"
          >
            <dojo-icon-button [icon]="'arrow-left'" [iconSize]="18" class="h-auto" />
          </div>
          <ion-title class="common-small-ion-title">{{ state.topic?.code }}</ion-title>
          <div slot="end" class="w-8"></div>
        </div>
      </ion-toolbar>
    </ion-header>
  }
  <div main-content>
    @if (state.topic) {
      <div class="main-content-header">
        @if (!state.isMobile) {
          <div class="back-button mb-4">
            <dojo-button
              fill="clear"
              class="text-neutral-300"
              [customWidth]="70"
              [routerLink]="`/${RootUrlParts.LearnHub}`"
            >
              <dojo-icon [icon]="'arrow-left'" class="mr-1" [size]="'18'" />
              {{ 'back' | transloco }}
            </dojo-button>
          </div>
          <dojo-topic-breadcrumbs
            class="topic-breadcrumbs"
            [activePage]="state.activePage"
            [showPageBreadcrumb]="state.showPageBreadcrumb"
          />
        }
      </div>

      <div class="main-content-area">
        <div
          class="mb-4 flex h-[48px] w-[48px] items-center justify-center rounded-full md:h-[56px] md:w-[56px]"
          [ngClass]="['bg-dynamic-' + state.topic.topicLevel1?.color_name + '-400']"
          [class.mt-8]="!state.isMobile"
        >
          <dojo-icon
            [icon]="state.topic.icon!"
            [size]="state.isMobile ? 18 : 30"
            [alt]="state.topic.code"
            [ngClass]="['text-dynamic-' + state.topic.topicLevel1?.color_name + '-50']"
            [faPrefix]="'fas'"
          />
        </div>
        <div class="text-primary mb-2 text-2xl font-semibold">
          @if (!state.isMobile) {
            {{ state.topic.code }}
          }
          <dojo-localized-string [content]="state.topic.name" />
        </div>
        <div class="text-primary mb-6 text-lg">
          @if (state.topic.description | localize | async; as content) {
            <dojo-markdown-viewer [content]="content" />
          }
        </div>
        <div class="w-full" style="border-bottom: 1px solid var(--neutral-200)"></div>
        <div class="py-6">
          @if (state.activePage && !state.showEmptyState) {
            <div class="h-full overflow-auto">
              <dojo-content-blocks-renderer
                [blocks]="state.activePage.content"
                [defaultFormulaBookletUrl]="state.formulaBookletUrl ?? ''"
              />
              <dojo-related-articles [slugs]="state.activePage.related_pages" />
            </div>
          } @else if (state.showEmptyState) {
            <div class="pt-4">
              <dojo-empty-state
                [isIconBig]="true"
                [image]="'assets/images/topic-practice/construction-barrier.svg'"
                [imageHeight]="121"
                [header]="'practice.notes_coming_soon' | transloco"
                [disableAnimation]="true"
              />
            </div>
            <div class="mb-4 flex flex-col">
              <h3 class="text-primary mb-6 mt-8 text-lg font-semibold">{{ 'home_card.need_help' | transloco }}</h3>
              <dojo-card-link
                [routerLink]="`/${RootUrlParts.TopicPractice}`"
                [title]="'home_card.card_1.title' | transloco"
                [subtitle]="'home_card.card_1.subtitle' | transloco"
                [imageSrc]="
                  state.darkMode
                    ? 'assets/images/topic-practice/roundel-dark.svg'
                    : 'assets/images/topic-practice/roundel.svg'
                "
                class="mb-5"
              ></dojo-card-link>

              <dojo-card-link
                [routerLink]="`/${RootUrlParts.TopicPractice}`"
                [title]="'home_card.card_2.title' | transloco"
                [subtitle]="'home_card.card_2.subtitle' | transloco"
                [imageSrc]="'assets/images/topic-practice/emblem.svg'"
              ></dojo-card-link>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div sidebar-content class="overflow-hidden">
    @if (state.activePage?.content?.length && scrollableContainer()) {
      <div class="table-contents sidebar-content !px-3">
        <div class="text-primary mb-2 px-4 text-base font-medium">
          {{ 'learn_hub.on_this_page' | transloco }}
        </div>
        <dojo-content-block-toc [blocks]="state.activePage!.content!" [scrollableParent]="scrollableContainer()" />
      </div>
    }
  </div>
</dojo-page-layout>
